import { Switch } from 'react-router-dom';
import Route from './Route';
import ScrollToTop from '../ScrollToTop';

import HomePage from '../pages/home/page';

import SignIn from '../pages/Login';
import SignUp from '../pages/SignUp';
import ResetPassword from '../pages/ResetPassword';
import HomeAdminPage from '../pages/home-admin';

import RomaneioPage from '../pages/romaneio';
import CadastrarRomaneioPage from '../pages/romaneio/create';
import EditarRomaneioPage from '../pages/romaneio/edit';

import lote from '../pages/lote/edit'

import BoletimPage from '../pages/boletim';
import CadastrarBoletimPage from '../pages/boletim/create';
import EditarBoletimPage from '../pages/boletim/edit';

import CadernoPage from '../pages/caderno';
import CadastrarCadernoPage from '../pages/caderno/create';
import EditarCadernoPage from '../pages/caderno/edit';

import CotacaoPage from '../pages/cotacao';
import CadastrarCotacaoPage from '../pages/cotacao/create';
import EditarCotacaoPage from '../pages/cotacao/edit';

import ProdutoPage from '../pages/produto';
import CadastrarProdutoPage from '../pages/produto/create';
import EditarProdutoPage from '../pages/produto/edit';

import ProdutoGrupoPage from '../pages/produtoGrupo';
import CadastrarProdutoGrupoPage from '../pages/produtoGrupo/create';
import EditarProdutoGrupoPage from '../pages/produtoGrupo/edit';

import PessoaPage from '../pages/pessoa/pessoas/index';
import CadastrarPessoaPage from '../pages/pessoa/pessoas/create';
import EditarPessoasPage from '../pages/pessoa/pessoas/edit';

import PedraPage from '../pages/pedra/index';
import CadastrarPedraPage from '../pages/pedra/create';
import EditarPedraPage from '../pages/pedra/edit';

import EstacionamentoPage from '../pages/estacionamento/index';
import CadastrarEstacionamentoPage from '../pages/estacionamento/create';
import EditarEstacionamentoPage from '../pages/estacionamento/edit';

import PropriedadePage from '../pages/propriedades/index';
import CadastrarPropiedadePage from '../pages/propriedades/create';
import EditarPropriedadePage from '../pages/propriedades/edit';

import PrecosPage from '../pages/precos/index';
import CadastrarPrecoPage from '../pages/precos/create';
import EditarPrecosPage from '../pages/precos/edit';

import MunicipioPage from '../pages/municipio/index';
import CadastrarMunicipioPage from '../pages/municipio/create';
import EditarMunicipioPage from '../pages/municipio/edit';

import LogsPage from '../pages/logs/index';
import EditarLogsPage from '../pages/logs/edit';

import HomeUser from '../pages/home-user';

import VafPage from '../pages/vaf';

import LojaPage from '../pages/loja/index';
import CadastrarLojaPage from '../pages/loja/create';
import EditarLojaPage from '../pages/loja/edit';

import RotasPage from '../pages/rotas/index';
import CadastrarRotaPage from '../pages/rotas/create';
import EditarRotaPage from '../pages/rotas/edit';
import { FormPermissoes } from '../components/FormPermissoes';
import PermissoesPage from '../pages/permissoes';
import CadastrarPermissoesPage from 'src/pages/permissoes/create';
import EditarPermissoesPage from 'src/pages/permissoes/edit';

export default function Routes() {
  return (
    <ScrollToTop>
      <Switch>

        <Route exact path="/" component={HomePage} />
        <Route exact path="/login" component={SignIn} />
        <Route exact path="/register" component={SignUp} />
        <Route exact path="/reset" component={ResetPassword} />
        <Route exact path="/home" component={HomeUser} isPrivate />
        <Route exact path="/admin" component={HomeAdminPage} isPrivate />

        <Route exact path="/romaneio" component={RomaneioPage} isPrivate />
        <Route exact path="/romaneiocreate" component={CadastrarRomaneioPage} isPrivate />
        <Route exact path="/romaneio/edit/:id" component={EditarRomaneioPage} isPrivate />

        <Route exact path="/lote/:lote" component={lote} />

        <Route exact path="/boletim" component={BoletimPage} isPrivate />
        <Route exact path="/boletimcreate" component={CadastrarBoletimPage} isPrivate />
        <Route exact path="/boletim/edit/:id" component={EditarBoletimPage} isPrivate />
        <Route exact path="/boletimitens/edit/:id" component={EditarBoletimPage} isPrivate />

        <Route exact path="/caderno/:id" component={CadernoPage} isPrivate />
        <Route exact path="/cadernocreate/:id" component={CadastrarCadernoPage} isPrivate />
        <Route exact path="/caderno/edit/:id" component={EditarCadernoPage} isPrivate />
        <Route exact path="/cadernoitens/edit/:id" component={EditarCadernoPage} isPrivate />

        <Route exact path="/cotacao" component={CotacaoPage} isPrivate />
        <Route exact path="/cotacao/create" component={CadastrarCotacaoPage} isPrivate />
        <Route exact path="/cotacao/edit/:id" component={EditarCotacaoPage} isPrivate />

        <Route exact path="/produto" component={ProdutoPage} isPrivate />
        <Route exact path="/produtocreate" component={CadastrarProdutoPage} isPrivate />
        <Route exact path="/produto/edit/:id" component={EditarProdutoPage} isPrivate />

        <Route exact path="/produtoGrupo" component={ProdutoGrupoPage} isPrivate />
        <Route exact path="/produtoGrupocreate" component={CadastrarProdutoGrupoPage} isPrivate />
        <Route exact path="/produtoGrupo/edit/:id" component={EditarProdutoGrupoPage} isPrivate />

        <Route exact path="/pedra" component={PedraPage} isPrivate />
        <Route exact path="/pedracreate" component={CadastrarPedraPage} isPrivate />
        <Route exact path="/pedra/edit/:id" component={EditarPedraPage} isPrivate />

        <Route exact path="/precos" component={PrecosPage} isPrivate />
        <Route exact path="/precoscreate" component={CadastrarPrecoPage} isPrivate />
        <Route exact path="/precos/edit/:id" component={EditarPrecosPage} isPrivate />

        <Route exact path="/pessoa" component={PessoaPage} isPrivate />
        <Route exact path="/pessoacreate" component={CadastrarPessoaPage} isPrivate />
        <Route exact path="/pessoa/:id" component={EditarPessoasPage} isPrivate />

        <Route exact path="/propriedade/:id" component={EditarPropriedadePage} isPrivate />
        <Route exact path="/propriedadecreate" component={CadastrarPropiedadePage} isPrivate />
        <Route exact path="/propriedade" component={PropriedadePage} isPrivate />

        <Route exact path="/vaf"component={VafPage} isPrivate/>

        <Route exact path="/estacionamento" component={EstacionamentoPage} isPrivate />
        <Route exact path="/estacionamentocreate" component={CadastrarEstacionamentoPage} isPrivate />
        <Route exact path="/estacionamento/edit/:id" component={EditarEstacionamentoPage} isPrivate />

        <Route exact path="/municipio" component={MunicipioPage} isPrivate />
        <Route exact path="/municipiocreate" component={CadastrarMunicipioPage} isPrivate />
        <Route exact path="/municipio/edit/:id" component={EditarMunicipioPage} isPrivate />

        <Route exact path="/loja" component={LojaPage} isPrivate />
        <Route exact path="/lojacreate" component={CadastrarLojaPage} isPrivate />
        <Route exact path="/loja/edit/:id" component={EditarLojaPage} isPrivate />

        <Route exact path="/rotas" component={RotasPage} isPrivate />
        <Route exact path="/rotascreate" component={CadastrarRotaPage} isPrivate />
        <Route exact path="/rotas/edit/:id" component={EditarRotaPage} isPrivate />

        <Route exact path="/logs" component={LogsPage} isPrivate />
        <Route exact path="/logs/edit/:id" component={EditarLogsPage} isPrivate />

        <Route exact path="/permissoes" component={PermissoesPage} isPrivate />
        <Route exact path="/permissoescreate" component={CadastrarPermissoesPage} isPrivate />
        <Route exact path="/permissoes/edit/:id" component={EditarPermissoesPage} isPrivate />

      </Switch>
    </ScrollToTop>
  )
}
